<script context="module" lang="ts">
  export type Config = {
    tableId: string;
    stickyHeader?: boolean;
    stickyFirstColumn?: boolean;
    stickyLastColumn?: boolean;
    multilineColumns?: boolean;
    showCheckboxes?: boolean;
    hideActions?: boolean;
    enableDeleteAll?: boolean;
    enableSubTables?: boolean;
    columnWidth?: string;
  };

  export type DisplayConfigItem = {
    key: string;
    value?: boolean;
    label: string;
    desc: string;
    configurable?: boolean;
  };

  export type ColumnValue = string | number | null;

  export type ColumnMask = {
    values: ColumnValue[];
    mask: ColumnValue;
  };

  export type Column =
    | {
        renderBy: "formatter" | "checkbox" | "dropdown" | "image";
        dataKey: string;
        label: string;
        sortBy?: string;
        formatter?: (value: ColumnValue) => ColumnValue;
        width?: string;
        isClickable?: boolean;
        masking?: ColumnMask;
        fitContent?: boolean;
      }
    | {
        renderBy: "actions";
        actions: any;
        width?: string;
      };

  export type Pagination = {
    count: number;
    page: number;
    pageSize: number;
  };

  export const configInfo: DisplayConfigItem[] = [
    {
      key: "stickyHeader",
      label: "Sticky Header",
      desc: "Make header sticky",
      configurable: true,
    },
    {
      key: "stickyFirstColumn",
      label: "Sticky First Column",
      desc: "Make first column sticky",
      configurable: true,
    },
    {
      key: "stickyLastColumn",
      label: "Sticky Last Column",
      desc: "Make last column sticky",
      configurable: true,
    },
    {
      key: "multilineColumns",
      label: "Enable Auto Line Wrap",
      desc: "Column text will overflow to second line automatically",
      configurable: true,
    },
    {
      key: "showCheckboxes",
      label: "Show Checkboxes",
      desc: "Use checkboxes as the first column",
      configurable: false,
    },
    {
      key: "hideActions",
      label: "Hide Actions",
      desc: "Hide Actions",
      configurable: true,
    },
    {
      key: "enableDeleteAll",
      label: "Enable Delete All",
      desc: "Shows the Delete All button in the table actions section. Requires checkboxes to be enabled",
      configurable: false,
    },
    {
      key: "enableSubTables",
      label: "Show Channels (Publisher)",
      desc: "Displays dropdown arrows for selection of channels",
      configurable: false,
    },
  ];
</script>
